import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';

/**
 * Structural directive: renders its template only when the connected agency account holds the
 * permission (or one of the permissions, when an array is given). Re-evaluated when the user
 * changes (login, refreshed role).
 *
 *   <button *appHasPermission="'USER_MANAGE'">Inviter</button>
 */
@Directive({
  selector: '[appHasPermission]',
  standalone: true,
})
export class HasPermissionDirective implements OnInit, OnDestroy {
  private required: string | string[] | null = null;
  private hasView = false;
  private subscription?: Subscription;

  constructor(
    private templateRef: TemplateRef<unknown>,
    private viewContainer: ViewContainerRef,
    private permissionService: PermissionService,
    private auth: AuthService
  ) {}

  @Input()
  set appHasPermission(value: string | string[] | null) {
    this.required = value;
    this.update();
  }

  ngOnInit(): void {
    this.subscription = this.auth.getUser().subscribe(() => this.update());
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  private update(): void {
    const allowed = Array.isArray(this.required)
      ? this.permissionService.hasAny(this.required)
      : this.permissionService.has(this.required);
    if (allowed && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!allowed && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
